import { useEffect, useRef, useState } from 'react';

// "Que versao esta no servidor agora?" — sonda compartilhada.
//
// Nasceu dentro do `ExibicaoPix` em 2026-06-25, depois de o quiosque do balcao ficar
// preso numa release antiga com o deploy ja no ar. Virou peca propria em 16/08/2026,
// quando o MESMO problema apareceu no AppCel do celular do balcao — a `BALCAO` e' a
// unica conta isenta do corte das 05h ([DA-414]), entao e' o unico aparelho que
// ninguem nunca obriga a recarregar a pagina. Ele passou dias com o JavaScript de
// antes da [DA-545] e mostrava a faixa de so-leitura num celular que o servidor
// deixava responder.
//
// ⚠️ **A sonda e' compartilhada; a REACAO nao.** O quiosque recarrega na hora (nao ha
// ninguem digitando num visor virado pro cliente); o AppCel espera um momento seguro,
// porque ali existe gente escrevendo mensagem. Por isso o hook DETECTA e avisa, e quem
// decide o que fazer e' cada tela. Unificar as duas reacoes seria trocar um bug por
// outro: recarga no meio de uma frase perde a frase.
//
// ⚠️ `cache: 'no-store'` e' OBRIGATORIO. Sem ele o proprio fetch volta do cache do
// navegador, o `baseline` nunca muda e a tela fica presa PARA SEMPRE achando que esta
// atualizada — que e' exatamente o modo de falhar que esta peca existe pra matar.
// Mordeu em 2026-06-25.

const INTERVALO_MS = 60_000;

/**
 * Acompanha a versao no ar e chama `aoMudar` UMA vez por mudanca.
 *
 * A primeira leitura so estabelece a linha de base — nunca dispara `aoMudar`, senao
 * toda abertura de tela pareceria uma release nova. `'dev'` nunca conta.
 *
 * Devolve a versao corrente pra quem quiser exibir (o quiosque mostra no rodape).
 */
export function useVersaoNoAr(aoMudar: () => void): string | null {
  const [versao, setVersao] = useState<string | null>(null);
  // Em ref, nao em dependencia: a tela passa uma funcao nova a cada render, e po-la no
  // array de dependencias remontaria o intervalo sem parar.
  const aoMudarRef = useRef(aoMudar);
  aoMudarRef.current = aoMudar;

  useEffect(() => {
    let baseline: string | null = null;
    let vivo = true;

    const checar = async () => {
      try {
        const r = await fetch('/api/version', { cache: 'no-store' });
        if (!r.ok) return;
        const d = (await r.json()) as { versao?: string };
        const v = d?.versao;
        if (v && vivo) setVersao(v);
        if (!v || v === 'dev') return;
        if (baseline == null) { baseline = v; return; }
        if (v !== baseline && vivo) {
          baseline = v;
          aoMudarRef.current();
        }
      } catch { /* silencioso — rede de seguranca, nunca erro na cara de ninguem */ }
    };

    void checar();
    const iv = setInterval(() => { if (vivo) void checar(); }, INTERVALO_MS);

    // Tambem confere ao ACORDAR: com a tela apagada o navegador congela o `setInterval`,
    // entao um deploy ocorrido enquanto o aparelho dormia so seria pego muito depois — ou
    // nunca, num celular que passa a noite no balcao.
    const aoVisivel = () => { if (document.visibilityState === 'visible') void checar(); };
    document.addEventListener('visibilitychange', aoVisivel);

    return () => {
      vivo = false;
      clearInterval(iv);
      document.removeEventListener('visibilitychange', aoVisivel);
    };
  }, []);

  return versao;
}
